<template>
  <b-row>
    <b-col cols="12">
      <n-h-r-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import NHREditForm from './NHREditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    NHREditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
